var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M32.923 13h-6.716a1.119 1.119 0 00-1.08 1.15v4.937a1.119 1.119 0 001.079 1.149h6.716A1.119 1.119 0 0034 19.087V14.15A1.119 1.119 0 0032.923 13zm0 8.484h-6.716a1.119 1.119 0 00-1.079 1.149v2.047H20.8a1.1 1.1 0 00-1.056 1.125v3.331h4.227c1.01.036 1.804.88 1.776 1.891v2.564h4.879v-.876a.743.743 0 111.484 0v.876h.833A1.1 1.1 0 0034 32.467v-9.833a1.119 1.119 0 00-1.077-1.15zM17.9 24.681h-2.826A1.119 1.119 0 0014 25.83v8.016c-.02.614.46 1.13 1.074 1.154H17.9a1.119 1.119 0 001.079-1.149V25.83a1.119 1.119 0 00-1.079-1.149zm6.02 5.306h-3.093a1.119 1.119 0 00-1.079 1.149v1.8a1.119 1.119 0 001.079 1.149h3.092A1.119 1.119 0 0025 32.939v-1.8a1.119 1.119 0 00-1.082-1.152h.002z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
